// eslint-disable

export const getRecorder = `query GetRecorder($id: ID!) {
  getRecorder(id: $id) {
    id
    assign
    connected
    name
    organizationId
    status
    version
    type
    tenant
    application
    timestamp
    network
  }
}
`
export const listRecorders = `query ListRecorders(
  $filter: TableRecorderFilterInput!
  $limit: Int
  $nextToken: String
) {
  listRecorders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      assign
      connected
      name
      organizationId
      status
      version
      type
      tenant
      application
      timestamp
      network
    }
    nextToken
  }
}
`
